<script setup lang="ts">
    /**
     * Implements software requirement: H1SR-80, H1SR-85
     *
     * @link https://formuslabs.youtrack.cloud/issue/H1SR-80/The-Home-Button-Formus-Logo-directs-the-user-to-the-dashboard
     * @link https://formuslabs.youtrack.cloud/issue/H1SR-85/Revoke-user-authentication-when-user-clicks-the-logout-button
     */
    import { ROUTES } from '@/router';
    import { useAuth } from '@/stores/auth';
    import { onBeforeUnmount } from 'vue';
    import AppHeaderCase from '@/views/header/AppHeaderCase.vue';
    import { APP_TARGETS } from '@/domain/analytics/analyticsTargets';
    import { useCaseSyncStore } from '@/stores/useCaseSyncStore';
    import CaseNotifications from '@/views/header/CaseNotifications.vue';
    import SupportMenu from '@/views/header/SupportMenu.vue';
    import ProfileMenu from '@/views/header/ProfileMenu.vue';
    import ThemeMenu from '@/views/header/ThemeMenu.vue';
    import { useUserStore } from '@/stores/userStore';

    const auth = useAuth();
    const user = useUserStore();

    const caseSyncStore = useCaseSyncStore();

    onBeforeUnmount(() => {
        caseSyncStore.stop();
    });
</script>

<template>
    <header>
        <div v-if="!auth.isLoggedIn" class="app-logo-manufacturer">
            <router-link :to="{ name: ROUTES.HOME }">
                <img alt="Formuslabs Logo" src="../../assets/images/formus-full-logo.svg" />
            </router-link>
        </div>
        <div
            v-if="auth.isLoggedIn"
            class="app-logo-manufacturer"
            :data-analytics-id="APP_TARGETS.formusLogo"
        >
            <router-link :to="{ name: ROUTES.HOME }" data-testid="formus-home-button">
                <img alt="Formuslabs Emblem" src="../../assets/images/formus-emblem.svg" />
            </router-link>
            <v-divider vertical color="white"></v-divider>
            <img alt="ZB Emblem" src="../../assets/images/zimmer-emblem.svg" />
        </div>

        <AppHeaderCase v-if="caseSyncStore.isCaseSpecific" />

        <nav v-if="auth.isLoggedIn">
            <CaseNotifications v-if="caseSyncStore.isCaseSpecific" />

            <SupportMenu />

            <ProfileMenu />

            <ThemeMenu v-if="user.isAdmin" />
        </nav>
    </header>
</template>

<style scoped lang="scss">
    header {
        background-color: rgb(var(--v-theme-dark-blue));
        //background-color: rgb(var(--v-theme-dark-blue));
        box-shadow: 0 10px 0 #00000005;
        display: flex;
        left: 0;
        width: calc(100% + 0px);
        align-items: center;
        justify-content: space-between;
        max-height: 80px;
        padding: 1.25rem 2.5rem;
    }

    nav {
        display: flex;
    }

    .app-logo-manufacturer {
        display: flex;
        justify-content: start;
        align-items: start;
    }

    .app-logo-manufacturer > * {
        margin: 20px 10px;
    }

    .app-logo-manufacturer :deep(.v-divider--vertical) {
        opacity: 1;
    }

    .app-logo-manufacturer img {
        position: relative;
        top: 4px;
    }
</style>
